var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99976 1H7.99988V2H7.99976V3H8.99976H9.99976H10.9998V4H9.99976V10H9.99988V11L9.99976 11H8.99976H2.99988L1.99988 11V10V4H0.999756V3H1.99988H2.99988H3.99988V2V1H4.99988H6.99976H7.99976ZM6.99976 2H4.99988V3H6.99976V2ZM6.99976 4H4.99988H3.99988L2.99988 4V10H8.99976V4L7.99976 4H6.99976ZM4.49976 5H5.49976V9H4.49976V5ZM7.49988 5H6.49988V9H7.49988V5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashS);
export default __webpack_public_path__ + "static/media/trash-s.e9d30ae32f1e057fe9d02164c1fef24d.svg";
export { ForwardRef as ReactComponent };